if (!customElements.get('upsell-slider')) {
  class UpsellSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.options = {
        draggable: true,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 10,
        navigation: {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev'),
        },
      };

      this.slider = new Swiper(this.querySelector('.swiper'), this.options);
    }
  }
  customElements.define('upsell-slider', UpsellSlider);
}
